import { atom } from "jotai";

// Advance notice of a planned maintenance window, set by useVersionCheck from
// the backend's version response. null when there is none.
export const maintenanceNoticeAtom = atom(null);
